export default __webpack_public_path__ + "static/media/thinktankData.2061a66b.txt";